/* eslint-disable no-undef */
// Helper function to determine if filter tracking errors should be reported to Sentry
function shouldReportFilterTrackingError(error) {
  // Don't report user navigation away or aborted requests
  if (error.name === 'AbortError') {
    return false;
  }

  // For fetch errors, check if it's a network error vs server error
  if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
    // This is usually a network connectivity issue - don't spam Sentry
    return false;
  }

  // Report server errors and other significant issues
  return true;
}

// Utility function to clear filter tracking state
window.clearFilterTrackingState = function () {
  if (typeof Storage !== 'undefined') {
    sessionStorage.removeItem('uh_filters_applied');
  }

  // Clear backend cache via API call
  if (typeof fetch !== 'undefined') {
    fetch('/api/v1/launchdarkly/clear-filter-state', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(() => {
      // Silent fail for cleanup operations
    });
  }
};

// Check session storage for filter application state and send to backend
(function () {
  if (typeof Storage !== 'undefined') {
    const filtersApplied = sessionStorage.getItem('uh_filters_applied');

    if (filtersApplied) {
      try {
        const filterData = JSON.parse(filtersApplied);

        // Check if filter data is too old (older than 1 hour) and clear it
        if (filterData.timestamp) {
          const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
          const filterTimestamp = new Date(filterData.timestamp);

          if (filterTimestamp < oneHourAgo) {
            window.clearFilterTrackingState();
            return;
          }
        }

        // Store filter state in cache via API call (backend will use standardized storage)
        // Check if LaunchDarkly is enabled before making API call
        const launchDarklyEnabled = window.config?.launchDarkly?.enabled;

        if (launchDarklyEnabled) {
          fetch('/api/v1/launchdarkly/session-filter-state', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              filters_applied: true,
              filter_data: filterData,
            }),
          }).catch((error) => {
            // Report significant failures to Sentry
            if (shouldReportFilterTrackingError(error)) {
              // eslint-disable-next-line no-undef
              if (typeof Sentry !== 'undefined') {
                // eslint-disable-next-line no-undef
                Sentry.captureException(error, {
                  tags: {
                    component: 'filter-tracking',
                    action: 'session_filter_state',
                  },
                  extra: {
                    filter_data: filterData,
                  },
                });
              }
            }
          });
        }
      } catch (error) {
        // Failed to parse filter state - clear invalid state
        window.clearFilterTrackingState();
      }
    }
  }
})();
